/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Automatic fix failed" |
*
* @param {Qc_Fix_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_failed_toast = /** @type {((inputs?: Qc_Fix_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la correction automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Korrektur fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correzione automatica non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое исправление не удалось")
	if (locale === "es") return /** @type {LocalizedString} */ ("La corrección automática falló")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动修复失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動修正に失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित सुधार विफल रहा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A correção automática falhou")
	return /** @type {LocalizedString} */ ("Automatic fix failed")
});